import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import PasswordInput from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import KapeiLogo from "@/components/KapeiLogo";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await login(email, password);
      toast.success("Sesión iniciada");
      const to = location.state?.from?.pathname || "/";
      navigate(to);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto flex min-h-screen max-w-md flex-col px-6 py-6">
        <Link to="/"><KapeiLogo className="mb-8" /></Link>
        <h1 className="mb-2 text-4xl font-black tracking-tight text-slate-900">Entrar</h1>
        <p className="mb-8 text-base text-slate-600">Accede para ver tus pedidos y enviar archivos a tu nombre.</p>

        <form onSubmit={onSubmit} className="flex flex-col gap-5">
          <div>
            <Label htmlFor="email" className="text-sm font-bold uppercase tracking-widest text-slate-700">Email</Label>
            <Input
              data-testid="login-email"
              id="email" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-14 rounded-xl border-2 border-slate-300 px-4 text-lg"
              placeholder="tu@email.com"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm font-bold uppercase tracking-widest text-slate-700">Contraseña</Label>
            <PasswordInput
              data-testid="login-password"
              id="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-14 rounded-xl border-2 border-slate-300 px-4 text-lg"
              placeholder="••••••••"
            />
          </div>
          {err && <div data-testid="login-error" className="rounded-xl bg-red-50 p-3 text-sm font-bold text-red-700">{err}</div>}
          <Button
            data-testid="login-submit"
            type="submit" disabled={loading}
            className="kapei-btn-huge bg-[#4d7c0f] text-white hover:bg-[#3f6212]"
          >
            {loading ? "Entrando…" : "Entrar"}
          </Button>

          <Link
            to="/forgot-password"
            className="text-center text-sm font-bold text-[#4d7c0f] underline"
          >
            ¿Olvidaste tu contraseña?
          </Link>
        </form>

        <p className="mt-8 text-center text-base text-slate-700">
          ¿No tienes cuenta?{" "}
          <Link data-testid="goto-register" to="/register" className="font-extrabold text-[#4d7c0f] underline">
            Crear cuenta
          </Link>
        </p>      </div>
    </div>
  );
}
